window.dataLayer = window.dataLayer || [];

const GTMDataLayer = {
  _lastViewItem: null,
  _lastViewItemTime: 0,

  pushEvent(eventName, ecommerceData) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ecommerce: ecommerceData
    });
  },

  viewItemList(items, listId, listName, currency) {
    this.pushEvent('dm_view_item_list', {
      item_list_id: listId,
      item_list_name: listName,
      currency: currency,
      items: items
    });
  },

  selectItem(item, listId, listName, currency) {
    this.pushEvent('dm_select_item', {
      item_list_id: listId,
      item_list_name: listName,
      currency: currency,
      items: [item]
    });
  },

  viewItem(item, value, currency) {
    const now = Date.now();
    const key = item.item_id + '_' + item.item_variant_id;

    if (this._lastViewItem === key && now - this._lastViewItemTime < 1000) {
      return;
    }

    this._lastViewItem = key;
    this._lastViewItemTime = now;

    this.pushEvent('dm_view_item', {
      currency: currency,
      value: value,
      items: [item]
    });
  },

  addToCart(item, value, currency) {
    this.pushEvent('dm_add_to_cart', {
      currency: currency,
      value: value,
      items: [item]
    });
  },

  removeFromCart(item, value, currency) {
    this.pushEvent('dm_remove_from_cart', {
      currency: currency,
      value: value,
      items: [item]
    });
  },

  viewCart(items, value, currency) {
    this.pushEvent('dm_view_cart', {
      currency: currency,
      value: value,
      items: items
    });
  },

  /**
   * Suggested bundle dropdown UI events (BYOB preset selector).
   * Clears ecommerce before each push so GTM/GA4 does not inherit prior payloads.
   */
  pushSuggestedBundleEvent(eventName, payload = {}) {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: eventName,
      ...payload
    });
  },

  suggestedBundleDropdownView(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_dropdown_view', payload);
  },

  suggestedBundleDropdownOpen(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_dropdown_open', payload);
  },

  suggestedBundleOptionView(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_option_view', payload);
  },

  suggestedBundleOptionSelect(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_option_select', payload);
  },

  suggestedBundleAddToCart(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_add_to_cart', payload);
  },

  suggestedBundleDropdownClose(payload) {
    this.pushSuggestedBundleEvent('dm_suggested_bundle_dropdown_close', payload);
  }
};

window.GTMDataLayer = GTMDataLayer;

GTMDataLayer.fetchAndTrackCart = function() {
  fetch('/cart.json')
    .then(response => response.json())
    .then(cart => {
      const items = cart.items.map(item => ({
        item_name: item.product_title,
        item_id: item.product_id.toString(),
        price: item.final_price / 100,
        item_brand: item.vendor || '',
        item_category: item.product_type || '',
        item_variant_id: item.variant_id.toString(),
        item_variant: item.variant_title || '',
        quantity: item.quantity
      }));
      const value = cart.total_price / 100;
      const currency = cart.currency;
      this.viewCart(items, value, currency);
    })
    .catch(() => {});
};

// dm_select_item - click on any interactive element within product card
document.addEventListener('click', (event) => {
  const cardWrapper = event.target.closest('.card-wrapper[data-gtm-item-id]');
  if (!cardWrapper) return false;

  // Check if clicked on an interactive element (a, button, input, or element with click handler)
  const interactive = event.target.closest('a, button, [role="button"], input, select, [tabindex="0"]');
  if (!interactive) return false;

  const item = {
    item_name: cardWrapper.dataset.gtmItemName,
    item_id: cardWrapper.dataset.gtmItemId,
    price: Number.parseFloat(cardWrapper.dataset.gtmItemPrice),
    item_brand: cardWrapper.dataset.gtmItemBrand,
    item_category: cardWrapper.dataset.gtmItemCategory,
    item_variant_id: cardWrapper.dataset.gtmItemVariantId,
    item_variant: cardWrapper.dataset.gtmItemVariant,
    item_list_name: cardWrapper.dataset.gtmItemListName,
    item_list_id: cardWrapper.dataset.gtmItemListId,
    quantity: 1
  };

  const currency = window.shopSettings?.isoCode || 'USD';
  GTMDataLayer.selectItem(item, item.item_list_id, item.item_list_name, currency);
  return true
});

